export const PRODUCTS = [
  {
    id: 'fue-standard',
    name: 'FUE Standard',
    products: [
      {
        id: 'fue-500-grafts',
        label: '500 Grafts',
        rowLabel: 'FUE 500 Grafts',
        price: 7580,
        isNoShaveAllowed: true,
        isDiscountDisabled: false,
      },
      {
        id: 'fue-750-grafts',
        label: '750 Grafts',
        rowLabel: 'FUE 750 Grafts',
        price: 10430,
        isNoShaveAllowed: true,
        isDiscountDisabled: false,
      },
      {
        id: 'fue-1000-grafts',
        label: '1000 Grafts',
        rowLabel: 'FUE 1000 Grafts',
        price: 13900,
        isNoShaveAllowed: true,
        isDiscountDisabled: false,
      },
      {
        id: 'fue-1250-grafts',
        label: '1250 Grafts',
        rowLabel: 'FUE 1250 Grafts',
        price: 15480,
        isNoShaveAllowed: true,
        isDiscountDisabled: false,
      },
      {
        id: 'fue-1500-grafts',
        label: '1500 Grafts',
        rowLabel: 'FUE 1500 Grafts',
        price: 16430,
        isNoShaveAllowed: true,
        isDiscountDisabled: false,
      },
      {
        id: 'fue-1750-grafts',
        label: '1750 Grafts',
        rowLabel: 'FUE 1750 Grafts',
        price: 17870,
        isNoShaveAllowed: false,
        isDiscountDisabled: false,
      },
      {
        id: 'fue-max-grafts',
        label: 'MaxGraft',
        rowLabel: 'FUE MaxGraft',
        price: 18150,
        isNoShaveAllowed: false,
        isDiscountDisabled: false,
      },
    ],
  },
  {
    id: 'other',
    name: 'Other',
    products: [
      {
        id: 'bundle-max-grafts-lllt',
        label: 'MAX RESULTS: MaxGraft and LLLT',
        rowLabel: 'MAX RESULTS: MaxGraft and LLLT',
        price: 20150,
        isNoShaveAllowed: false,
        isDiscountDisabled: false,
      },
      {
        id: 'bundle-max-grafts-laser-cap',
        label: 'MAX RESULTS: MaxGraft and Laser Cap',
        rowLabel: 'MAX RESULTS: MaxGraft and Laser Cap',
        price: 20150,
        isNoShaveAllowed: false,
        isDiscountDisabled: false,
        taxable: 2000, // Only the Laser Cap product is taxable
      },
      {
        id: 'lllt-max-results',
        label: 'LLLT Max Results',
        rowLabel: 'LLLT Max Results',
        price: 3460,
        isNoShaveAllowed: false,
        isDiscountDisabled: false,
      },
      {
        id: 'laser-cap',
        label: 'Laser Cap',
        rowLabel: 'Laser Cap',
        price: 2699,
        isNoShaveAllowed: false,
        isDiscountDisabled: false,
        taxable: 'all',
      },
      {
        id: 'genetic-testing',
        label: 'Genetic Testing',
        rowLabel: 'Genetic Testing',
        price: 0,
        isNoShaveAllowed: false,
        isDiscountDisabled: false,
      },
      {
        id: 'rx-compound',
        label: 'Rx Compound',
        rowLabel: 'Rx Compound',
        price: 499,
        isNoShaveAllowed: false,
        isDiscountDisabled: false,
      },
      {
        id: 'prp-restore-plus',
        label: 'PRP Restore+',
        rowLabel: 'PRP Restore+: Three PRP Sessions',
        price: 2250,
        isNoShaveAllowed: false,
        isDiscountDisabled: false,
      },
      {
        id: 'prp-restore',
        label: 'PRP Restore',
        rowLabel: 'PRP Restore: Three PRP Sessions',
        price: 1500,
        isNoShaveAllowed: false,
        isDiscountDisabled: true,
      },
    ],
  },
];
